import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Modal, Progress } from "antd";

class ModalRecalculating extends Component {
	static propTypes = {
		visible    : PropTypes.bool.isRequired,
		finished   : PropTypes.bool,
		description: PropTypes.node,
		hint       : PropTypes.node,
		percent    : PropTypes.number,
	};

	static defaultProps = {
		finished   : false,
		description: null,
		hint       : "Isso pode levar alguns segundos.",
		percent    : null,
	};

	state = {
		percent: 0,
	};

	componentDidUpdate(prevProps) {
		if( this.props.visible && !prevProps.visible && this.props.percent === null )
		{
			this.start();
		}

		if( this.props.finished && !prevProps.finished )
		{
			this.stop();
			this.setState({ percent: 100 });
		}

		if( !this.props.visible && prevProps.visible )
		{
			this.stop();
		}
	}

	componentWillUnmount() {
		this.stop();
	}

	start = () => {
		this.stop();
		this.setState({ percent: 0 });

		this._timer = setInterval(() => {
			this.setState((state) => ({
				percent: Math.min(90, state.percent + Math.max(1, Math.round((90 - state.percent) / 8))),
			}));
		}, 300);
	};

	stop = () => {
		if( this._timer )
		{
			clearInterval(this._timer);
			this._timer = null;
		}
	};

	render() {
		const percent = this.props.percent ?? this.state.percent;

		return (
			<Modal
				open={this.props.visible}
				footer={null}
				closable={false}
				maskClosable={false}
				keyboard={false}
				centered
				width={560}
				className="time-card-modal"
			>
				<div className="time-card-progress">
					<span className="time-card-progress-icon"><i className="far fa-sync-alt fa-spin" /></span>
					<h3>Recalculando</h3>
					<p>{this.props.description}</p>
					<p>{this.props.hint}</p>
					<Progress percent={percent} status={percent < 100 ? "active" : "normal"} />
					<p className="time-card-progress-safe">
						<i className="fal fa-shield-check" />
						Seus dados estão seguros. Não feche esta tela.
					</p>
				</div>
			</Modal>
		);
	}
}

export default ModalRecalculating;
